// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-description-content__content-text{font-family:OpenSans;line-height:1.7}.more-job-title{color:#00a0dd}", ""]);
// Exports
module.exports = exports;
